import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {IndividualSubCriteriaScore} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-section-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe],
  host: {class: 'flex w-full items-center justify-between gap-4 pr-4'},
  templateUrl: './rfi-section-header.component.html',
})
export class RfiSectionHeaderComponent {
  readonly score = input<IndividualSubCriteriaScore>();
}
